import React from 'react';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import KPICard from './KPICard';
import { formatCurrency, formatPercentage } from '../../../utils/dashboardFormatters';
import ArrowUpIcon from '../../icons/ArrowUpIcon';

const MetricsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '16px',
  marginBottom: '26px',
  flexWrap: 'wrap'
}));

const KPIMetricsSection = ({ metrics = {} }) => {
  const safeString = (v) => (v == null ? '-' : String(v));
  const kpiData = [
    {
      title: 'Total Revenue',
      value: formatCurrency(metrics.totalRevenue),
      icon: <ArrowUpIcon width={5} height={9} color="#0b91d6" />
    },
    {
      title: 'One Time Revenue',
      value: formatCurrency(metrics.oneTimeRevenue || metrics.oneTimeMRR),
      icon: <ArrowUpIcon width={5} height={9} color="#0b91d6" />
    },
    {
      title: 'Total Client Revenue',
      value: safeString(metrics.totalClientMRR),
      icon: <ArrowUpIcon width={5} height={9} color="#0b91d6" />
    },
    {
      title: 'Total Client One Shot',
      value: safeString(metrics.totalClientOneShort || metrics.totalClientOneShot),
      icon: <ArrowUpIcon width={5} height={9} color="#0b91d6" />
    },
    {
      title: 'Number of Family Account',
      value: safeString(metrics.familyAccountCount),
      icon: <ArrowUpIcon width={5} height={9} color="#0b91d6" />
    },
    {
      title: 'Total\nAccounts',
      value: safeString(metrics.totalAccounts),
      icon: <ArrowUpIcon width={5} height={9} color="#0b91d6" />
    },
    {
      title: 'Profile Activity Rate',
      value: formatPercentage(metrics.profileActivityRatio),
      icon: <ArrowUpIcon width={5} height={9} color="#0b91d6" />
    }
  ];

  return (
    <MetricsContainer>
      {kpiData.map((kpi, index) => (
        <KPICard
          key={index}
          title={kpi.title}
          value={kpi.value}
          icon={kpi.icon}
        />
      ))}
    </MetricsContainer>
  );
};

export default KPIMetricsSection;